import React from 'react'
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import { MusicPlay } from 'components/musicPlay';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
    root: {
        width: "100%",
        height: "100vh",
        padding: "0 10%",
        background: "linear-gradient(150deg, rgb(10, 10, 10, 0.60) 30%, rgb(30, 30, 30, 0.20) 50%, rgb(10, 10, 10, 0.60) 70%)",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: "column",
        overflow: "hidden",
        position: "relative",
    },
    typography: {
        textAlign: "center",
        textShadow: "5px 5px 0px rgba(255, 255, 255, 0.3)",
        fontFamily: "Basic",
        fontSize: "30px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "normal",
        textTransform: "uppercase",
        color: "rgba(255, 255, 255, 0)",
        textStroke: "1px #fff",
        [theme.breakpoints.up('md')]: {
            fontSize: "50px",
        },
    },
    typography1: {
        textAlign: "center",
        fontFamily: "Basic",
        fontSize: "32px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "normal",
        textTransform: "uppercase",
        color: "rgba(255, 255, 255, 1)",
        [theme.breakpoints.up('md')]: {
            fontSize: "80px",
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: "110px",
        },
    },
    musicPlay: {
        position: "absolute",
        left: 0,
        right: 0,
        bottom: "40px",
        margin: "0 auto",
        padding: "0 10%",
    },
    pagePaddingTop: {
        padding: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        [theme.breakpoints.up('md')]: {
            paddingTop: theme.spacing(5),
            paddingBottom: theme.spacing(5),
        },
    },
    sectionAlternate: {
        '& .section-alternate__content': {
            padding: theme.spacing(3),
            paddingBottom: theme.spacing(3),
            [theme.breakpoints.up('md')]: {
                paddingTop: theme.spacing(5),
                paddingBottom: theme.spacing(5),
            },
        },
    },
    image: {
        objectFit: 'cover',
        borderRadius: theme.spacing(0, 0, 20, 0),
    },
    blogContent: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    list: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
}));

const Banner = () => {

    const classes = useStyles();
    const theme = useTheme()
    // console.log(theme)

    const BannerData = useSelector((state) => state.cover.discovers.home);
    return (
        <div className={classes.root}>
            <Typography className={classes.typography1}>
                {BannerData?.index_discover_title}
            </Typography>
            <Typography className={classes.typography}>
                {BannerData?.index_discover_sub_title}
            </Typography>

            <Box className={classes.musicPlay}>
                <MusicPlay />
            </Box>
        </div>
    )
}


Banner.propTypes = {
    /**
     * External classes
     */
    className: PropTypes.string,
};


export default Banner
